export const redirectToUrl = (redirect_to: string) => {
  redirect_to && window.location.assign(redirect_to);
};
